import { render } from "./InfoSedes.vue?vue&type=template&id=f3c04e58&scoped=true"
import script from "./InfoSedes.vue?vue&type=script&lang=js"
export * from "./InfoSedes.vue?vue&type=script&lang=js"

import "./InfoSedes.vue?vue&type=style&index=0&id=f3c04e58&scoped=true&lang=scss"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3c04e58"]])

export default __exports__